/*
 * global-error-handler.ts
 * utms-admin-dashboard
 *
 * Created by Tetiana Makovii on 19.04.2022
 * Copyright © 2026 Sonova AG. All rights reserved.
 */

import { ErrorHandler, Injectable, NgZone } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportingService } from './error-reporting.service';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(
    private zone: NgZone,
    public snackBar: MatSnackBar,
    private errorReportingService: ErrorReportingService,
  ) {}

  handleError(error: any) {
    this.zone.run(() => {
      if (error != undefined)
        this.snackBar.open(error, 'X', { panelClass: 'auto-width' });
    });

    console.error('Error from global error handler: ', error);
    this.errorReportingService.captureException(error);
  }
}
